function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4 4a4 4 0 0 1 4-4h26.343a4 4 0 0 1 2.829 1.172l13.656 13.656A4 4 0 0 1 52 17.657V52a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4Z",
    fill: "#B98EFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: "4",
    y: "0",
    width: "48",
    height: "56"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 4a4 4 0 0 1 4-4h26.343a4 4 0 0 1 2.829 1.172l13.656 13.656A4 4 0 0 1 52 17.657V52a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V4Z",
    fill: "#B4D400"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 16a4 4 0 0 1-4-4V0l16 16H40Z",
    fill: "#CDAFFF"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F3ECFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 28a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-4.884-.53a.25.25 0 0 0-.354 0l-.353.353a.25.25 0 0 0 0 .354l1.06 1.06a.25.25 0 0 0 .354 0l1.768-1.767a.25.25 0 0 0 0-.354l-.354-.354a.25.25 0 0 0-.353 0L17.646 28l-.53-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 27a.5.5 0 0 1 .5-.5h15a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-15a.5.5 0 0 1-.5-.5v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 40a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-2 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 38.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-15Z"
  })));
};
var componentName = 'FileIcon';
export var FileIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    style: {
      fontSize: '56px'
    },
    ref: ref
  }, props));
});
FileIcon.displayName = componentName;